import "./App.css";
import { Link } from "react-router-dom";

function About() {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="applyImg fixed"></div>
      <div className="flex-1 relative z-10">
        <div className="pt-20 pb-16">
          <div className="xl:w-[70%] w-[90%] mx-auto px-6">
            {/* Hero Section */}
            <div className="text-center mb-12">
              <h1 className="text-5xl font-bold text-zinc-200 mb-4 text mt-6">
                Welcome to <span className="text-amber-400">Omnicraft SMP</span>
              </h1>
              <p className="text-2xl text-zinc-100 font-medium mb-2">
                A Friendly & Modded Minecraft Community
              </p>
              <p className="text-lg text-zinc-100 max-w-3xl mx-auto leading-relaxed">
                We are a welcoming and cooperative Minecraft server where
                players come together to build, explore, and thrive in a
                friendly community. Whether you're a seasoned adventurer or a
                casual builder, there's a place for you here!
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid lg:grid-cols-3 gap-8 mb-16">
              {/* Modded Gameplay */}
              <div className="bg-zinc-900/95 border border-zinc-700/50 rounded-xl p-8 shadow-xl hover:shadow-amber-500/10 transition-all duration-300 hover:border-amber-600/30 flex flex-col">
                <div className="flex items-center mb-4">
                  <div className="bg-gradient-to-r from-purple-500 to-indigo-500 p-3 rounded-lg mr-4">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-bold text-amber-400">
                    Modded Gameplay
                  </h2>
                </div>
                <p className="text-zinc-300 leading-relaxed flex-1">
                  Experience a fresh take on Minecraft with carefully selected
                  mods that enhance the game while keeping the spirit of
                  creativity and collaboration alive. All client mods are
                  allowed with no restrictions - play how you want to play!
                </p>
                <div className="mt-4 p-3 bg-purple-500/10 border border-purple-500/20 rounded-lg">
                  <p className="text-purple-200 text-sm">
                    💡 Server-side mod suggestions are open all season. Client &
                    server mods can be suggested between seasons during modpack
                    updates.
                  </p>
                </div>
              </div>

              {/* Community Driven */}
              <div className="bg-zinc-900/95 border border-zinc-700/50 rounded-xl p-8 shadow-xl hover:shadow-amber-500/10 transition-all duration-300 hover:border-amber-600/30 flex flex-col">
                <div className="flex items-center mb-4">
                  <div className="bg-gradient-to-r from-green-500 to-emerald-500 p-3 rounded-lg mr-4">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-bold text-amber-400">
                    Community Driven
                  </h2>
                </div>
                <p className="text-zinc-300 leading-relaxed flex-1">
                  Work together on ambitious builds, tackle exciting challenges,
                  or just relax and enjoy the game with like-minded players.
                  Worried about grief or PvP? Claim your land and protect it
                  from all damage.
                </p>
                <div className="mt-4 p-3 bg-green-500/10 border border-green-500/20 rounded-lg">
                  <p className="text-green-200 text-sm">
                    🛡️ Land claiming system ensures your builds stay safe while
                    you're offline.
                  </p>
                </div>
              </div>

              {/* Balanced Adventure */}
              <div className="bg-zinc-900/95 border border-zinc-700/50 rounded-xl p-8 shadow-xl hover:shadow-amber-500/10 transition-all duration-300 hover:border-amber-600/30 flex flex-col">
                <div className="flex items-center mb-4">
                  <div className="bg-gradient-to-r from-orange-500 to-red-500 p-3 rounded-lg mr-4">
                    <svg
                      className="w-6 h-6 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-bold text-amber-400">
                    Balanced Adventure
                  </h2>
                </div>
                <p className="text-zinc-300 leading-relaxed flex-1">
                  While cooperation is encouraged, the world is filled with
                  adventure, exploration, and just the right amount of challenge
                  to keep things interesting! If PvP is your thing, find
                  like-minded players and challenge them.
                </p>
                <div className="mt-4 p-3 bg-orange-500/10 border border-orange-500/20 rounded-lg">
                  <p className="text-orange-200 text-sm">
                    ⚔️ With our mod selection, there will always be something
                    new for you to discover!
                  </p>
                </div>
              </div>
            </div>

            {/* Call to Action Section */}
            <div className="bg-zinc-900/95 border border-zinc-700/50 rounded-xl p-8 shadow-xl text-center">
              <h3 className="text-3xl font-bold text-amber-400 mb-4">
                Ready to Join Our Community?
              </h3>
              <p className="text-xl text-zinc-300 mb-6 max-w-2xl mx-auto">
                Join us and become part of an amazing community where
                creativity, teamwork, and fun are at the heart of everything we
                do!
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <Link
                  to="/application"
                  className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-500 hover:to-orange-500 text-white font-bold py-4 px-8 rounded-lg shadow-lg flex items-center gap-2 transition-all transform hover:scale-105"
                >
                  <span>Apply Now</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="size-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
                    />
                  </svg>
                </Link>

                <a
                  href="https://discord.gg/uwcRznrJsp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white font-bold py-4 px-8 rounded-lg shadow-lg flex items-center gap-2 transition-all transform hover:scale-105"
                >
                  <span>Join Discord</span>
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.211.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418Z" />
                  </svg>
                </a>
              </div>

              <div className="mt-6 grid md:grid-cols-3 gap-4 text-sm text-zinc-400">
                <div className="flex items-center justify-center">
                  <svg
                    className="w-4 h-4 mr-2 text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Friendly Community
                </div>
                <div className="flex items-center justify-center">
                  <svg
                    className="w-4 h-4 mr-2 text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Optimized Server
                </div>
                <div className="flex items-center justify-center">
                  <svg
                    className="w-4 h-4 mr-2 text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  24/7 Uptime
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default About;
